import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const TenantIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 16H12.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16H16.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V8.5C21.0001 8.4103 20.9761 8.32223 20.9304 8.24502C20.8848 8.1678 20.8192 8.10429 20.7405 8.06114C20.6619 8.01798 20.5731 7.99678 20.4835 7.99975C20.3938 8.00271 20.3066 8.02974 20.231 8.078L15.769 10.922C15.6934 10.9703 15.6062 10.9973 15.5165 11.0003C15.4269 11.0032 15.3381 10.982 15.2595 10.9389C15.1808 10.8957 15.1152 10.8322 15.0696 10.755C15.0239 10.6778 14.9999 10.5897 15 10.5V8.5C15.0001 8.4103 14.9761 8.32223 14.9304 8.24502C14.8848 8.1678 14.8192 8.10429 14.7405 8.06114C14.6619 8.01798 14.5731 7.99678 14.4835 7.99975C14.3938 8.00271 14.3066 8.02974 14.231 8.078L9.77 10.922C9.69437 10.9705 9.60707 10.9978 9.51727 11.0009C9.42747 11.004 9.33849 10.9828 9.2597 10.9396C9.1809 10.8965 9.1152 10.8328 9.0695 10.7555C9.0238 10.6781 8.99979 10.5899 9 10.5V5C9 4.46957 8.78929 3.96086 8.41421 3.58579C8.03914 3.21071 7.53043 3 7 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16H8.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

TenantIcon.displayName = 'TenantIcon';
